"use strict";

var React = require("react"),
    PropTypes = require("prop-types"),
    ProgressDots = function ProgressDots(r) {
  for (var e = [], s = 0; s < r.numSteps; s++) {
    e.push(s);
  }

  var t = r.name || Math.random();
  return React.createElement("div", {
    style: r.style,
    className: "blx-progress-dots " + r.className
  }, e.map(function (e) {
    return React.createElement("label", {
      className: "blx-progress-dot-container",
      key: e
    }, React.createElement("input", {
      type: "radio",
      value: e,
      name: t,
      checked: e === r.currentStepIdx,
      onChange: r.onClick
    }), React.createElement("span", {
      className: "blx-progress-dot"
    }));
  }));
};

ProgressDots.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  name: PropTypes.string,
  numSteps: PropTypes.number,
  currentStepIdx: PropTypes.number,
  onClick: PropTypes.func
}, ProgressDots.defaultProps = {
  className: "",
  style: null,
  name: "",
  numSteps: 0,
  currentStepIdx: 0,
  onClick: function onClick() {}
}, module.exports = ProgressDots;